<template>
    <div class="row">
        <div 
            class="col-xs-12"
            :class="{ 'col-md-10 col-sm-9': !wide, 'col-sm-6': wide}"
        >
            <label :for="id">{{ label }}</label>
        </div>
        <div 
            class="col-xs-12 text-right"
            :class="{ 'col-md-2 col-sm-3': !wide, 'col-sm-6': wide}"
        >
            <label
                v-for="option in options"
                :key="option"
                class="form-check-label"
            >
                <input
                    type="radio"
                    :name="id"
                    :id="`${id}_${option}`"
                    v-bind="$attrs"
                    v-model="localVal"
                    :value="option"
                > {{ option }}</label>
            <error
                :name="id"
                :errors="errors"
            />
        </div>
    </div>
</template>

<script>
import UsesErrors from '../../../mixins/UsesErrors';
export default {
    mixins: [UsesErrors],
    props: {
        value: {
            required: false,
            default: null
        },
        options: {
            type: Array,
            required: false,
            default: () => {
                return ["Yes", "No"];
            }
        },
        label: {
            required: true,
            type: String
        },
        id: {
            required: true,
            type: String
        },
        placeholder: {
            required: false,
            type: String,
            default: 'Select...',
        },
        wide: {
            default: false,
            type: Boolean,
        },
        
    },
    data() {
        return {
            localVal: null,
        }
    },
    watch: {
        value: {
            handler: function(newValue) {
                this.localVal = newValue;
            },
            immediate: true,
        },
        localVal: {
            handler: function (newValue) {
                if (this.localVal !== this.value) {
                    this.$emit('input', newValue);
                }
            },
            immediate: true,
        }
    },
};
</script>

<style lang="scss" scoped>
.row {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/CheckboxRowComponent.vue